import { tns } from 'tiny-slider/src/tiny-slider';

class MegaFeaturedPosts {
	constructor(el) {
		this.el = el;
		this.slider = this.el.querySelector('.mega-featured-posts__slider');
		this.nav = this.el.querySelector('.mega-featured-posts__nav');

		if (!this.slider) {
			return;
		}

		const slideCount = this.slider.children.length;
		if (slideCount <= 1) {
			if (this.nav) {
				this.nav.style.display = 'none';
			}
			return;
		}

		this.el._megaFeaturedPosts = this;

		if (this.isVisible()) {
			this.initSlider();
		}
	}

	isVisible() {
		const panel = this.el.closest('.menu-taxonomy--additional-children');

		return !panel || panel.classList.contains('menu-taxonomy--active-children');
	}

	initSlider() {
		if (!this.slider || this.slider.dataset.tnsInitialized) {
			return;
		}

		this.slider.dataset.tnsInitialized = 'true';

		const megaFeaturedPostsSlider = tns({
			container: this.slider,
			items: 1,
			slideBy: 1,
			mouseDrag: true,
			preventScrollOnTouch: 'auto',
			swipeAngle: false,
			speed: 400,
			controls: false,
			nav: true,
			navContainer: this.nav,
			navPosition: 'bottom',
			autoplay: true,
			autoplayButtonOutput: false
		});

		return megaFeaturedPostsSlider;
	}
}

export default MegaFeaturedPosts;
